module.exports = __webpack_public_path__ + "images/emoji/triangular_flag_on_post.d1908fe80fdae8cea3b8.png";